/* eslint no-underscore-dangle: 0 */
/*eslint-disable*/
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import {
  Avatar,
  Box,
  CircularProgress,
  createTheme,
  Menu,
  MenuItem,
  ThemeProvider,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { debounce } from 'lodash';
import Template from '../../../utils/api/templates';
import { setErrorNotification } from '../../../redux/slices/NotificationSlice';
import {
  getCurrentTemplate,
  savedTemplateList,
  updateCurrentTemplate,
  setPage,
  updateSavedTemplate,
  clearPageCount,
  setTableFilter,
  setFilter,
} from '../../../redux/slices/TemplateSlice';
// import {
//   setTableFilter,
// } from '../../../redux/slices/MyContentSlice';
import {
  MoreMenuIconHorizontal,
  EditSavedTemplateNameIcon,
  TableFilterTagIcon,
  UnselectIcon,
} from '../../../shared/component/svgIcon';
import {
  capitalize, changeDateTimeFormat, checkFeatures, checkPermission,
  getCurrentLanguageCode,
} from '../../../utils/helpers';
import SearchBox from '../../../shared/component/form/SearchBox';
import TableFilter from '../../../shared/component/TableFilter';
import FilterDropDown from '../../../shared/component/FilterDropDown';
import FilterMapper from '../../../shared/component/FilterMapper';
import myContent from '../../../utils/api/my-content';
import TemplateMessageEmpty from './TemplateMessageEmpty';
import NoSearchResultsFound from './NoSearchResultsFound';
import DropDownMenu from '../../../shared/component/DropDownMenu';
// import TableFilterOption from '../../../shared/component/TableFilterOption';

function SavedTemplates() {
  // const {
  //   tableFilter,
  //   filter
  // } = useSelector((state) => state.myContent);
  const {
    savedTemplateData,
    pageCount,
    totalPageCount,
    status,
    tableFilter,
    filter,
  } = useSelector((state) => state?.currentTemplate);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const userName = JSON.parse(localStorage.getItem('data'));
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [closeModal, setCloseModal] = useState(true);
  const [editedTemplate, setEditedTemplate] = useState({});
  const [searchTemplate, setSearchTemplate] = useState('');
  const [inputActive, setInputActive] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterTag, setFilterTag] = useState(tableFilter?.filter || []);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [authors, setAuthors] = useState([]);
  const open = Boolean(anchorEl);
  // const savedTemplateData = [];
  let content;
  const theme = createTheme({
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            boxShadow: '0px 1px 12px 4px #00000014 !important',
            width: 'inherit',
          },
        },
      },
    },
  });

  const getSavedTemplates = (counts, filters) => {
    if (status === 'succeeded') {
      dispatch(savedTemplateList({ page: counts, limit: 20, ...filters }));
    }
  };

  useEffect(() => {
    if (pageCount === 0) {
      getSavedTemplates(1);
    }

    return () => {
      dispatch(clearPageCount(0));
    };
  }, []);
  const getDataFormat = (filteredValues) => {
    const transformedData = filteredValues?.reduce((acc, { key, result }) => {
      if (!acc?.[key]) {
        acc[key] = [];
      }
      acc?.[key]?.push(result);
      return acc;
    }, {});
    return transformedData;
  };
  const handleScroll = () => {
    let transformedData;
    if (tableFilter?.filter) {
      transformedData = getDataFormat(tableFilter?.filter);
    } else {
      transformedData = {};
    }
    getSavedTemplates(pageCount + 1, {
      ...transformedData,
      name: filter?.name,
    });
  };

  const permissionError = {
    message: 'view permission denied',
  };

  const handleNavigateHtml = (data) => {
    if (!closeModal) {
      setCloseModal(true);
    }
    if (checkPermission('getTemplatesList')
      && checkFeatures('templates', 'edit')) {
      navigate(`/admin/templates/edit-content/${data?.template_number}`);
      dispatch(getCurrentTemplate(data));
      dispatch(setPage('tab-2'));
    }
  };

  const handleDropdownClick = (event, template, index) => {
    setAnchorEl(event.currentTarget);
    setEditedTemplate(template);
    setSelectedIndex(index);
  };
  const handleClose = (data = editedTemplate) => {
    setAnchorEl(null);
    setSelectedIndex(null);
    setInputActive(false);
    const postData = [
      {
        _id: data?._id,
        multi_pricing: data?.multi_pricing,
        search_tags: data?.search_tags,
        styles: data?.styles,
        tags: data?.tags,
        template_backgroundImage_url: data?.template_backgroundImage_url,
        template_contents: data?.template_contents,
        template_image_url: data?.template_image_url,
        template_images: data?.template_images,
        template_name: data?.template_name,
        template_number: data?.template_number,
        template_type: data?.template_type,
        template_title: data?.template_title,
        clone: data?.clone,
        content_id: data?.content_id,
      },
    ];
    if (Object.keys(editedTemplate)?.length) {
      Template?.updateSavedTemplate(postData)?.then((res) => {
        dispatch(updateCurrentTemplate({ ...res?.data }));
      })
        .catch((error) => dispatch(setErrorNotification(error?.response?.data)));
    }
  };

  const handleDeleteClick = (id) => {
    if (
      checkPermission('getTemplatesList') &&
      checkFeatures('templates', 'delete') &&
      closeModal
    ) {
      Template?.deleteSavedTemplates(id)
        .then(() => {
          const newData = savedTemplateData.filter((item) => item?._id !== id);
          dispatch(updateSavedTemplate(newData));
        })
        .catch((error) =>
          dispatch(setErrorNotification(error?.response?.data))
        );
      setAnchorEl(null);
    }
  };

  // const handleEditName = (e) => {
  //   if (checkPermission('getTemplatesList')
  //     && checkFeatures('templates', 'edit')) {
  //     const newData = JSON.parse(JSON.stringify(savedTemplateData));
  //     if (e.target.value.length >= 0) {
  //       newData[selectedIndex].template_name = e.target.value;
  //       setCloseModal(true);
  //     } if (e.target.value.length === 0 || e.target.value.length > 25) {
  //       setCloseModal(false);
  //     }
  //     setEditedTemplate(newData[selectedIndex]);
  //     dispatch(updateSavedTemplate(newData));
  //   } else {
  //     dispatch(setErrorNotification(permissionError));
  //   }
  // };

  const handleEditName = (id, newName) => {
    if (checkPermission('getTemplatesList') && checkFeatures('templates', 'edit')) {
      // Create a deep clone of the state
      const newData = JSON.parse(JSON.stringify(savedTemplateData));
      const index = newData.findIndex((item) => item._id === id);
      if (index !== -1) {
        if (newName.length > 0 && newName.length <= 25) {
          newData[index].template_name = newName;
          setCloseModal(true);
        } else {
          setCloseModal(false);
        }
        setEditedTemplate(newData[index]);
        dispatch(updateSavedTemplate(newData));
        // handleClose();
      }
    } else {
      dispatch(setErrorNotification(permissionError));
    }
  };

  const handleCloneClick = (clone) => {
    // if (closeModal) 
    const cloned = JSON.parse(JSON.stringify(clone));
    cloned.clone = true;
    setAnchorEl(null);
    setCloseModal(true);
    dispatch(getCurrentTemplate(cloned));
    // dispatch(updateSavedTemplate(cloned));
    dispatch(setPage('tab-2'));
    navigate(`/admin/templates/edit-content/${clone?.template_number}`);
    // }
  };

  // const handleChangeSearchTemplate = (name, changeValue) => {
  //   setSearchTemplate(changeValue);
  //   dispatch(savedTemplateList({ name: changeValue, tag: changeValue }));
  // };
  const handleEditIcon = () => {
    setInputActive(true);
  };
  const onFilterFunction = (filteredValues) => {
    setFilterTag(filteredValues);
    // dispatch(setTableFilter({ ...tableFilter, filter: filteredValues }));
    // const transformedData = getDataFormat(filteredValues);
    // getSavedTemplates(pageCount, transformedData);
    // getContents(1, { ...filter, ...transformedData });
  };
  const applyFilter = (filteredValues) => {
    setFilterTag(filteredValues);
    dispatch(setTableFilter({ ...tableFilter, filter: filteredValues }));
    const transformedData = getDataFormat(filteredValues);
    getSavedTemplates(
      1,
      {
        ...filter, ...transformedData, sortBy: tableFilter?.sortBy, sortField: tableFilter?.sortField,
      },
    );
  };
  const onSearchHandle = debounce((changeValue) => {
    if (changeValue?.length > 0) {
      dispatch(setFilter({ ...filter, search: changeValue }));
      const transformedData = getDataFormat(filterTag);
      const object = {
        ...filter,
        ...transformedData,
        search: changeValue,
      };
      getSavedTemplates(1, object);
    } else {
      dispatch(setFilter({}));
      const transformedData = getDataFormat(filterTag);
      getSavedTemplates(1, {
        ...transformedData,
      });
    }
  }, 1500);
  const handleSearchChange = useCallback((name, value) => {
    if (name === 'searchTemplate') {
      setSearchTemplate(value); // Update local search state immediately
      onSearchHandle(value);
    }
  }, []);
  const handleFilterTagRemove = (tag) => {
    let updatedFilters;

    if (
      tag?.filterBy === 'Date Uploaded'
      || tag?.key === 'startDate'
      || tag?.key === 'endDate'
    ) {
      updatedFilters = filterTag.filter(
        (filters) => filters?.filter_by !== tag?.filter_by,
      );
    } else {
      updatedFilters = filterTag.filter(
        (filters) => !(filters?.filter_by === tag?.filter_by && filters?.result === tag?.result),
      );
    }
    setFilterTag(updatedFilters);
    onFilterFunction(updatedFilters);
    applyFilter(updatedFilters);
  };

  const handleClear = () => {
    onFilterFunction([]);
    applyFilter([]);
  };

  useEffect(() => {
    if (isFilterOpen) {
      myContent.getAuthors().then((response) => {
        setAuthors(response?.data);
      }).catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
    }
  }, [isFilterOpen]);
  if (status !== 'loading') {
    if (savedTemplateData?.length === 0) {
      content = searchTemplate?.length > 0
        ? <NoSearchResultsFound />
        : (
          <TemplateMessageEmpty
            title={t('noSavedTemplatesYet')}
            subtitle={t('noTemplateMessage')}
          />
        );
    } else {
      content = (
        <div className="s_template-list">
          {savedTemplateData?.map((template, tempIndex) => (
            <div className="s_template-grid" key={template?._id}>
              <div className="s_template-grid-img">
                <div
                  role="presentation"
                  className="images"
                  onClick={() => handleNavigateHtml(template)}
                >
                  <img
                    src={template?.signedUrl ? template?.signedUrl : template?.template_image_url}
                    alt="templateImage"
                    loading="lazy"
                    style={{
                      objectFit: (template?.template_type === 'Bar Display'
                        || template?.template_type === 'Shelf Display')
                        ? 'contain'
                        : 'inherit',
                    }}
                  />
                </div>
              </div>
              <div className="s_template-footer">
                <div className="avatar">
                  <div className="avatar">
                    <Avatar className="avatar-img-tx">
                      <span>
                        {capitalize(userName?.user?.name?.charAt(0))}
                      </span>
                    </Avatar>
                    <p>
                      {template?.template_name}
                    </p>
                  </div>
                  <div
                    className={selectedIndex === tempIndex ? 'option-icon-visible' : 'option-icon'}
                    onClick={(event) => handleDropdownClick(event, template, tempIndex)}
                    role="presentation"
                  >
                    <DropDownMenu
                      tooltipPosition="top-start"
                      icon={<MoreMenuIconHorizontal />}
                      value={
                        {
                          id: template?._id,
                          name: template?.template_name
                        }
                      }
                      editableName
                      top
                      dropdown="tableForm"
                      templateClose={handleClose}
                      // handleEditName={(id, newName) => {
                      //   handleEditName({ target: { value: newName } });  // adapt to your handler
                      // }}
                      handleEditName={handleEditName}
                      action={[
                        {
                          name: t('cloneTemplate'),
                          function: () => handleCloneClick(template),
                          id: 'clone',
                          sendFullDetails: true,
                          disabled: !(checkPermission('editTemplates') && checkFeatures('templates', 'edit'))
                        },
                        {
                          name: t('delete'),
                          function: () => handleDeleteClick(template?._id),
                          id: 'delete',
                          key: 'delete',
                          sendFullDetails: true,
                          disabled: !(checkPermission('deleteTemplates') && checkFeatures('templates', 'delete'))
                        }
                      ]}
                    />
                    {/* <MoreMenuIconHorizontal /> */}
                  </div>
                  {/* <ThemeProvider theme={theme}>
                    <Menu
                      // id={`menu-${tempIndex}`}
                      anchorEl={anchorEl}
                      open={open && selectedIndex === tempIndex}
                      onClose={closeModal && (() => handleClose(editedTemplate))}
                      // MenuListProps={{
                      //   'aria-labelledby': 'basic-button',
                      // }}
                      sx={{ width: '40%' }}
                    >
                      <MenuItem
                        key={`menuitem-${selectedIndex}-edit-input`}
                        sx={{ backgroundColor: '#ffffff !important', padding: '10px 0px 0px 20px !important' }}
                      >
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          fontSize: '18px',
                          fontWeight: '600',
                          paddingBottom: '0px',
                        }}
                        >
                          {
                            !inputActive
                            && (
                              <span
                                className="title-name"
                                style={{ width: '80%' }}
                              >
                                {template?.template_name}
                              </span>
                            )
                          }
                          {inputActive
                            && (
                              <input
                                value={template?.template_name}
                                style={{ border: 'none', outline: 'none', width: '80%' }}
                                disabled={!checkPermission('getTemplatesList')
                                  || !checkFeatures('templates', 'edit')}
                                onChange={(e) => handleEditName(e, editedTemplate)}
                                onKeyDown={(e) => e.stopPropagation()}
                                className="title-input"
                              />
                            )}
                          {
                            checkPermission('editTemplates') && checkFeatures('templates', 'edit') && (
                              <Box
                                // sx={{ margin: inputActive ? '5px 0px 0px 20px' : '3px 0px 0px 10px' }}
                                sx={{ width: '10%', paddingTop: '5px' }}
                                onClick={handleEditIcon}
                                role="none"
                              >
                                <EditSavedTemplateNameIcon />
                              </Box>
                            )
                          }
                        </Box>
                      </MenuItem>
                      {
                        !closeModal
                        && (
                          <Box sx={
                            {
                              margin: '0', padding: '0px', color: 'red', fontSize: '11px', textAlign: 'center',
                            }
                          }
                          >
                            <span>
                              Template Name cannot be empty and <br />
                              must be no more than 25 characters
                            </span>
                          </Box>
                        )
                      }
                      <Box sx={{ border: '0.75px solid #D0D5DD', width: '90%', margin: '10px' }} />
                      <MenuItem
                        key={`menuitem-${selectedIndex}-clone`}
                        sx={{
                          paddingX: '20px',
                          paddingY: '10px',
                          '&:hover': {
                            background:
                              'linear-gradient(180deg, rgba(25, 167, 153, 0.15) 0%, rgba(85, 186, 137, 0.15) 100%)',
                            margin: '0px 10px',
                            paddingX: '10px',
                          },
                        }}
                        onClick={() => handleCloneClick(editedTemplate)}
                      >
                        {t('cloneTemplate')}
                      </MenuItem>
                      <MenuItem
                        key={`menuitem-${selectedIndex}-delete`}
                        sx={{
                          paddingX: '20px',
                          paddingY: '10px',
                          color: '#DA3E33',
                          '&:hover': {
                            backgroundColor: '#FFECE5',
                            margin: '0px 10px',
                            paddingX: '10px',
                          },
                        }}
                        onClick={() => handleDeleteClick(editedTemplate?._id)}
                        disabled={!checkPermission('deleteTemplates')
                          || !checkFeatures('templates', 'delete')}
                        role="presentation"
                      >
                        {t('Delete')}
                      </MenuItem>
                    </Menu>
                  </ThemeProvider> */}

                </div>
                <div className="created-date">
                  <span>{changeDateTimeFormat(template?.updatedAt)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }
  }

  return (
    <div
      className={getCurrentLanguageCode() === 'ar'
        ? 'saved-templates-arabic' : 'saved-templates'}
    >
      {/* {savedTemplateData?.length > 0 && ( */}
      <div className={filterTag?.length > 0 ? 'top-container-filter' : 'top-container'}>
        <div className="search-template">
          <SearchBox
            icon={' '}
            type="text"
            name="searchTemplate"
            value={searchTemplate}
            change={handleSearchChange}
            placeholder={t('searchByTemplateName')}
          />
        </div>
        <TableFilter
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          title={t('Filters')}
          viewByName={t('Templates')}
          isFilterOpen={isFilterOpen}
          disabled={status === 'loading'}
          applyFilter={applyFilter}
          filterTag={filterTag}
          tagCount={filterTag?.length || 0}
          setIsFilterOpen={setIsFilterOpen}
          filterData={
            [
              {
                name: t('Date Uploaded'),
                component: <FilterDropDown
                  setFilter={onFilterFunction}
                  filter={filterTag}
                  keyValue="dateUploaded"
                  selectedFilter={selectedFilter}
                />,
              },
              {
                name: t('Created By'),
                component: <FilterMapper
                  content={authors}
                  setFilter={onFilterFunction}
                  filter={filterTag}
                  keyValue="createdBy"
                  selectedFilter={selectedFilter}
                />,
              },
            ]
          }
        />
      </div>
      {/* )} */}
      {
        filterTag?.length > 0
        && (
          <div className="table-filter-view-wrapper">
            <div className="table-filter-view">
              {filterTag?.map((value) => (
                <div className="filter-tag">
                  <span><TableFilterTagIcon /></span>
                  <span>{value?.filterBy}</span> :
                  <span>{value?.result}</span>
                  <span onClick={() => handleFilterTagRemove(value)} role="none"><UnselectIcon /></span>
                </div>
              ))}
            </div>
            <p onClick={handleClear} role="none">Clear({filterTag?.length})</p>
          </div>
        )
      }
      <InfiniteScroll
        dataLength={savedTemplateData?.length}
        style={{ display: 'flex', flexDirection: 'column' }}
        next={handleScroll}
        height="100vh"
        hasMore={pageCount < totalPageCount}
      // loader={status === 'loading' && (
      //   <h4 className="text-center">
      //     <Box>
      //       <CircularProgress color="success" />
      //     </Box>
      //   </h4>
      // )}
      >
        {status === 'loading' ? (
          <div className="content-layout-loader-wrap">
            <CircularProgress color="success" />
          </div>
        ) : (
          content
        )}

        {/* {status !== 'loading' && (
          savedTemplateData?.length === 0 ? (
            searchTemplate?.length > 0 ? (
              <NoSearchResultsFound />
            ) : (
              <TemplateMessageEmpty />
            )
          ) : (
          )
        )} */}
      </InfiniteScroll>
    </div>
  );
}

export default SavedTemplates;
